eyebrow: "Book a Call"
headline: "Let's talk about<br/><em>your workflow.</em>"
lead: "A 30-minute discovery call. No sales pitch — we'll look at your current processes, identify where AI creates real leverage, and tell you honestly what's worth building."

details:
  - icon: "⏱️"
    text: "30 minutes — no fluff"
  - icon: "🎯"
    text: "Focused on your specific workflow"
  - icon: "🤝"
    text: "Straight talk on what's realistic"
  - icon: "📋"
    text: "You'll leave with a clear next step"

placeholder:
  icon: "📅"
  title: "Book a Discovery Call"
  body: "Replace this placeholder with your Calendly embed once your account is live."
  link:
    label: "Or email hello@banoffee.work →"
    href: "mailto:hello@banoffee.work"

contactForm:
  title: "Prefer email?"
  namePlaceholder: "Your name"
  emailPlaceholder: "your@email.com"
  messagePlaceholder: "Tell us briefly about your workflow..."
  button: "Send Message →"
  success: "Got it! We'll be in touch within 24 hours."
